import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { updateSingleFilter } from '@src/store/slices/searchFiltersSlice';

import Select from '@components/select';

// ---------------------------------------------------------

const SelectRedux = (props) => {
  const dispatch = useDispatch();
  const value = useSelector((state) => state.searchFilters[props.id]);

  // ---------------------------------------------------------

  const onChange = (value) => {
    dispatch(updateSingleFilter({ group: props.id, value }));
  };

  // ---------------------------------------------------------

  return <Select {...props} selected={value} onChange={onChange} />;
};

// ---------------------------------------------------------

SelectRedux.propTypes = {
  /**
   * Id to serve as the location where to store the value in the redux store
   */
  id: PropTypes.string.isRequired
};

SelectRedux.defaultProps = {};

export default SelectRedux;
